export default function (value) {
  if (value === 'Sent') return 'Sent Pitch'
  return value || ''
}
